import { ActionReducerMapBuilder, createSlice } from '@reduxjs/toolkit';
import { getSharedLocations } from '../services/locations.service';
import { LocationLightDTO } from '../../services/location.service';
import { GeofenceLightDTO } from '../../services/geofence.service';
import { getSharedGeofences } from '../services/geofence.service';

type SharedEntity<T = any> = {
  isFailed: boolean;
  isLoading: boolean;
  all: T;
  current: T;
  total: number;
};

type SharedLocations = SharedEntity<LocationLightDTO[]>;
type SharedGeofences = SharedEntity<GeofenceLightDTO[]>;

type SharedSlice = {
  locations: SharedLocations;
  geofences: SharedGeofences;
};

const sharedEntityInitialState: SharedEntity = {
  isFailed: false,
  isLoading: false,
  all: [],
  current: [],
  total: 0,
};

const initialState: SharedSlice = {
  locations: sharedEntityInitialState,
  geofences: sharedEntityInitialState,
};

const locationsReducers = (builder: ActionReducerMapBuilder<SharedSlice>) => {
  builder.addCase(getSharedLocations.pending, (state) => {
    state.locations.isLoading = true;
  });
  builder.addCase(getSharedLocations.fulfilled, (state, action) => {
    state.locations.isLoading = false;
    state.locations.isFailed = false;
    state.locations.total = action.payload.totalItems;

    if (!action.meta.arg.filters?.search) {
      state.locations.all = action.payload.items.sort((a, b) =>
        a.group.name.localeCompare(b.group.name),
      );
    }

    state.locations.current = action.payload.items.sort((a, b) =>
      a.group.name.localeCompare(b.group.name),
    );
  });

  builder.addCase(getSharedLocations.rejected, (state) => {
    state.locations.isLoading = false;
    state.locations.isFailed = true;
  });
};

const geofencesReducers = (builder: ActionReducerMapBuilder<SharedSlice>) => {
  builder.addCase(getSharedGeofences.pending, (state) => {
    state.geofences.isLoading = true;
  });
  builder.addCase(getSharedGeofences.fulfilled, (state, action) => {
    state.geofences.isLoading = false;
    state.geofences.isFailed = false;
    state.geofences.total = action.payload.totalItems;

    if (!action.meta.arg.filters?.search) {
      state.geofences.all = action.payload.items.sort((a, b) =>
        a.name.localeCompare(b.name),
      );
    }

    state.geofences.current = action.payload.items.sort((a, b) =>
      a.name.localeCompare(b.name),
    );
  });

  builder.addCase(getSharedGeofences.rejected, (state) => {
    state.geofences.isLoading = false;
    state.geofences.isFailed = true;
  });
};

export const sharedSlice = createSlice({
  name: 'shared',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    locationsReducers(builder);
    geofencesReducers(builder);
  },
});
